<cm-info-section title="Uploaded document(s)">
    <cm-files-list
        [maxSize]="maxSize"
        [files]="step.content.documents"
        class="uploaded-documents-files"
    ></cm-files-list>
</cm-info-section>
